export const normalizeFacetLabel = label => {
  if (
    label === 'editedBy' ||
    label === 'createdBy' ||
    label === 'itemMentions' ||
    label === 'contentMentions'
  ) {
    return 'user';
  }
  if (label === 'itemTags' || label === 'contentTags') {
    return 'tags';
  }

  return label;
};
